import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check } from "lucide-react";

export default function SSORedirectUrl({ redirectUrl }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    if (!redirectUrl) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(redirectUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            /* clipboard not available */
        }
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("ssoSettings.redirectUrlLabel")}
            </label>
            <p className="text-xs text-gray-500 mb-2">{t("ssoSettings.redirectUrlHelp")}</p>
            <div className="flex gap-2">
                <input type="text" readOnly value={redirectUrl}
                    className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm bg-gray-50 text-gray-700" />
                <button type="button" onClick={handleCopy}
                    className="inline-flex items-center gap-1 px-3 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50">
                    {copied ? <Check className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />}
                    {copied ? t("ssoSettings.copied") : t("ssoSettings.copy")}
                </button>
            </div>
        </div>
    );
}
